import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { CompanyEmailTemplate } from '../../companies/companies.models';
import { AuthService } from 'src/app/core/auth.service';
import { AlertService } from 'src/app/core/alert.service';
import { EmailTemplatesComponent } from 'src/app/shared/email-templates/email-templates.component';

@Component({
  selector: 'app-default-email-templates',
  templateUrl: './default-email-templates.component.html',
  styleUrls: ['./default-email-templates.component.scss']
})
export class DefaultEmailTemplatesComponent implements OnInit {
  @ViewChild('emailTemplatesComponent') emailTemplatesComponent: EmailTemplatesComponent;
  public emailTemplates: CompanyEmailTemplate[] = [];
  public canUpdate: boolean = this.authService.hasAuthority('CUD_GD');
  public url = `${Constants.contextPath}/default-email-templates`;

  constructor(private baseService: BaseService, private authService: AuthService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.baseService.getAll(`${this.url}/list`, (response: CompanyEmailTemplate[]) => {
      this.emailTemplates = response;
    });
  }

  saveTemplate(event) {
    if(!event.id) {
      this.baseService.create(this.url, event, (response) => {
        this.emailTemplates.push(response);
        this.emailTemplatesComponent.closeEmailTemplateFormModal();
        this.alertService.success('DEFAULT_EMAIL_TEMPLATE.CREATED_SUCCESSFULLY');
      });
    } else {
      this.baseService.update(this.url, event, (response) => {
        let index = this.emailTemplates.findIndex(t => t.id == response.id);
        if(index > -1) {
          this.emailTemplates[index] = response;
          this.emailTemplatesComponent.closeEmailTemplateFormModal();
          this.alertService.success('DEFAULT_EMAIL_TEMPLATE.UPDATED_SUCCESSFULLY');
        }
      })
    }
  }

  deleteTemplate(event) {
    this.baseService.delete(this.url, event, () => {
      let index = this.emailTemplates.findIndex(t => t.id == event);
        if(index > -1) {
          this.emailTemplates.splice(index, 1);
          this.alertService.success('SHARED.DELETE_SUCCESS');
        }
    })
  }
}
